import type { ToneOverlay } from "../index.js";

export const overlay: ToneOverlay = {
  "alert.toast.new": "{hazard} reportado na sua área",
  "alert.toast.escalation": "{hazard} nas imediações agravou-se",
  "alert.toast.inPath": "{hazard} está a avançar na direção da sua localização",
  "alert.toast.allClear": "Situação normalizada perto de {place}",
  "alert.toast.tap": "Abra para consultar os detalhes e orientações de segurança",
  "alert.takeover.title": "{hazard} — ação imediata necessária",
  "alert.takeover.details": "Ver relatório completo",
  "now.status.allClear": "Sem perigos ativos.",
  "now.status.stayAware": "Mantenha-se vigilante.",
  "now.status.sub.allClear": "Sem perigos ativos dentro do seu raio de vigilância.",
  "now.activity.empty": "Nenhuma atividade reportada nas imediações.",
  "onboarding.promise.tagline": "Uma rede comunitária de aviso antecipado.",
  "onboarding.promise.continue": "Iniciar",
  "region.unsupported.title": "Localização fora da área de cobertura",
  "you.voice.intro": "Selecione o tom com que o Beacon comunica.",
};
